import React, { useState, useContext, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './../../../assets/css/mentor/mentordashboard/StudentsQuestions.css';
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';
import axios from 'axios';
import AppContext from './../../../context/Appcontext';

const StudentQuestions = () => {
  const { baseUrl } = useContext(AppContext);
  const [filter, setFilter] = useState('all');
  const [viewMode, setViewMode] = useState('list');
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answerText, setAnswerText] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editAnswerText, setEditAnswerText] = useState('');
  // ========== UI STATES ==========
  const [isLoading, setIsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // ========== FETCH ALL QUESTIONS ==========
  const fetchQuestions = () => {
    const mentorData = JSON.parse(localStorage.getItem('mentorData'));
    if (!mentorData) return;

    setIsLoading(true);
    axios.get(`${baseUrl}/mentor/questions/${mentorData.id}`)
      .then((response) => {
        setQuestions(response.data.questions || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchQuestions();
  }, []);


  // ========== CREATE ==========
  const handleAnswerSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!answerText.trim()) {
      setErrorMessage('Please write an answer before submitting.');
      return;
    }

    const mentorData = JSON.parse(localStorage.getItem('mentorData'));
    setSubmitLoading(true);

    axios.post(`${baseUrl}/mentor/answer/create`, {
      question_id: selectedQuestion.id,
      mentor_id: mentorData.id,
      answer: answerText,
    })
      .then((response) => {
        setSubmitLoading(false);
        setSuccessMessage('Answer submitted successfully!');
        setAnswerText('');
        fetchQuestions();
        setTimeout(() => {
          setSuccessMessage('');
          setViewMode('list');
          setSelectedQuestion(null);
        }, 1500);
      })
      .catch((error) => {
        setSubmitLoading(false);
        handleApiError(error);
      });
  };

  // ========== UPDATE ==========
  const handleAnswerUpdate = (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!editAnswerText.trim()) {
      setErrorMessage('Answer field cannot be empty.');
      return;
    }

    setUpdateLoading(true);
axios.post(`${baseUrl}/mentor/answer/update/${selectedQuestion.id}`, {
  answer: editAnswerText,
})
      .then((response) => {
        setUpdateLoading(false);
        setSuccessMessage('Answer updated successfully!');
        setIsEditing(false);
        fetchQuestions();
        setTimeout(() => {
          setSuccessMessage('');
          setViewMode('list');
          setSelectedQuestion(null);
        }, 1500);
      })
      .catch((error) => {
        setUpdateLoading(false);
        handleApiError(error);
      });
  };
    
  // ========== ERROR HANDLER ==========
  const handleApiError = (error) => {
    console.error('API error:', error);
    if (error.response && error.response.data) {
      if (error.response.data.errors) {
        const errors = Object.values(error.response.data.errors).flat().join(', ');
        setErrorMessage(errors);
      } else if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Something went wrong. Please try again.');
      }
    } else {
      setErrorMessage('Network error. Please check your connection.');
    }
  };
  // ========== ANSWER BUTTON CLICK (pending question) ==========
  const handleAnswerClick = (question) => {
    setSelectedQuestion(question);
    setAnswerText('');
    setErrorMessage('');
    setSuccessMessage('');
    setViewMode('answer');
  };

  // ========== VIEW BUTTON CLICK (answered question) ==========
  const handleViewClick = (question) => {
    setSelectedQuestion(question);
    setEditAnswerText(question.answer || '');
    setIsEditing(false);
    setErrorMessage('');
    setSuccessMessage('');
    setViewMode('view');
  };

  // ========== BACK TO LIST ==========
  const handleBack = () => {
    setViewMode('list');
    setSelectedQuestion(null);
    setAnswerText('');
    setEditAnswerText('');
    setIsEditing(false);
    setErrorMessage('');
    setSuccessMessage('');
  };
     // ========== STATS how much ==========
  const totalQuestions = questions.length;
  const pendingQuestions = questions.filter(q => q.status === 'pending').length;
  const answeredQuestions = questions.filter(q => q.status === 'answered').length;

  // ========== FILTER which one==========
  const filteredQuestions = questions.filter(q => {
    if (filter === 'all') return true;
    if (filter === 'pending') return q.status === 'pending';
    if (filter === 'answered') return q.status === 'answered';
    return true;
  });

  // ========== RENDER LIST VIEW ==========
  const renderListView = () => (
    <div className="student-questions-wrapper">

      {/* Success Message */}
      {successMessage && (
        <div className="alert alert-success py-2 mb-3">
          <i className="bi bi-check-circle me-2"></i>
          {successMessage}
        </div>
      )}

      {/* Stats Cards */}
      <div className="sq-stats-grid">
        <div className="sq-stat-card">
          <div className="sq-stat-icon sq-stat-icon-total">
            <i className="bi bi-question-circle"></i>
          </div>
          <div className="sq-stat-content">
            <div className="sq-stat-label">TOTAL QUESTIONS</div>
            <div className="sq-stat-value">{totalQuestions}</div>
          </div>
        </div>

        <div className="sq-stat-card">
          <div className="sq-stat-icon sq-stat-icon-pending">
            <i className="bi bi-hourglass-split"></i>
          </div>
          <div className="sq-stat-content">
            <div className="sq-stat-label">PENDING QUESTIONS</div>
            <div className="sq-stat-value">{pendingQuestions}</div>
          </div>
        </div>

        <div className="sq-stat-card">
          <div className="sq-stat-icon sq-stat-icon-answered">
            <i className="bi bi-check-circle"></i>
          </div>
          <div className="sq-stat-content">
            <div className="sq-stat-label">ANSWERED QUESTIONS</div>
            <div className="sq-stat-value">{answeredQuestions}</div>
          </div>
        </div>
      </div>

      {/* Filter Buttons */}
      <div className="sq-filter-section">
        <div className="sq-filter-label">Filter by Status:</div>
        <div className="sq-filter-buttons">
          <button
            className={`sq-filter-btn ${filter === 'all' ? 'sq-filter-active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Questions
          </button>
          <button
            className={`sq-filter-btn ${filter === 'pending' ? 'sq-filter-active' : ''}`}
            onClick={() => setFilter('pending')}
          >
            Pending
          </button>
          <button
            className={`sq-filter-btn ${filter === 'answered' ? 'sq-filter-active' : ''}`}
            onClick={() => setFilter('answered')}
          >
            Answered
          </button>
        </div>
      </div>

      {/* Questions Table */}
      <div className="sq-card">
        <div className="sq-table-container">
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <p className="mt-2 text-muted">Loading questions...</p>
            </div>
          ) : (
            <table className="sq-table">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Subject</th>
                  <th>Question</th>
                  <th>Time</th>
                  <th>Status</th>
                  <th>Rating</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredQuestions.map(question => (
                  <tr key={question.id} className="sq-table-row">
                    <td>
                      <div className="sq-student-info">
                        <img
                          src={question.student_avatar || `https://randomuser.me/api/portraits/men/${question.id}.jpg`}
                          alt={question.student_name}
                          className="sq-student-avatar"
                        />
                        <span className="sq-student-name">{question.student_name}</span>
                      </div>
                    </td>
                    <td>
                      <span className="sq-subject-badge">{question.subject}</span>
                    </td>
                    <td>
                      <div className="sq-question-cell">{question.question}</div>
                    </td>
                    <td>
                      <span className="sq-time-text">{question.time_ago}</span>
                    </td>
                    <td>
                      <span className={`sq-status-badge sq-status-${question.status}`}>
                        {question.status === 'pending' ? 'PENDING' : 'ANSWERED'}
                      </span>
                    </td>
                    <td>
                      {question.rating ? (
                        <div className="sq-rating-display">
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className={`bi ${i < question.rating ? 'bi-star-fill' : 'bi-star'}`}
                              style={{ color: i < question.rating ? '#fbbf24' : '#d1d5db' }}
                            ></i>
                          ))}
                        </div>
                      ) : (
                        <span className="sq-no-rating">-</span>
                      )}
                    </td>
                    <td className="text-center">
                      {question.status === 'pending' ? (
                        <button
                          className="sq-btn-answer"
                          onClick={() => handleAnswerClick(question)}
                        >
                          <i className="bi bi-reply-fill"></i> Answer
                        </button>
                      ) : (
                        <button
                          className="sq-btn-view"
                          onClick={() => handleViewClick(question)}
                        >
                          <i className="bi bi-eye-fill"></i> View
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {!isLoading && filteredQuestions.length === 0 && (
            <div className="sq-empty-state">
              <i className="bi bi-inbox"></i>
              <p>No questions found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // ========== RENDER ANSWER FORM VIEW (CREATE) ==========
  const renderAnswerView = () => (
    <div className="student-questions-wrapper">

      {/* Back Button + Header */}
      <div className="sq-form-header">
        <button className="sq-back-btn" onClick={handleBack}>
          <i className="bi bi-arrow-left"></i> Back
        </button>
        <div>
          <h2 className="sq-form-title">Answer Question</h2>
          <p className="sq-form-subtitle">Write a detailed answer for the student</p>
        </div>
      </div>

      {/* Question Info Card */}
      <div className="sq-question-card">
        <div className="sq-question-card-header">
          <div className="sq-student-info">
            <img
              src={selectedQuestion?.student_avatar || `https://randomuser.me/api/portraits/men/${selectedQuestion?.id}.jpg`}
              alt={selectedQuestion?.student_name}
              className="sq-student-avatar"
            />
            <div>
              <span className="sq-student-name">{selectedQuestion?.student_name}</span>
              <span className="sq-subject-badge ms-2">{selectedQuestion?.subject}</span>
            </div>
          </div>
          <span className="sq-time-text">{selectedQuestion?.time_ago}</span>
        </div>
        <div className="sq-question-display">
          <i className="bi bi-chat-left-quote me-2 text-muted"></i>
          {selectedQuestion?.question}
        </div>
      </div>

      {/* Answer Form */}
      <div className="sq-card">
        <form onSubmit={handleAnswerSubmit} className="sq-answer-form-wrapper">
          <h5 className="sq-answer-form-heading">
            <i className="bi bi-pencil-square me-2"></i>
            Write your answer:
          </h5>

          {errorMessage && (
            <div className="alert alert-danger py-2 mb-3">
              <i className="bi bi-exclamation-triangle me-2"></i>
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="alert alert-success py-2 mb-3">
              <i className="bi bi-check-circle me-2"></i>
              {successMessage}
            </div>
          )}

          <textarea
            className="sq-answer-textarea"
            placeholder="Type your detailed answer here..."
            rows="6"
            value={answerText}
            onChange={(e) => setAnswerText(e.target.value)}
            required
          ></textarea>

          <div className="sq-form-actions">
            <button
              type="button"
              className="sq-btn-cancel"
              onClick={handleBack}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="sq-btn-submit"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Submitting...
                </>
              ) : (
                <>
                  <i className="bi bi-send-fill me-2"></i>
                  Submit Answer
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  // ========== RENDER VIEW + EDIT (READ + UPDATE) ==========
  const renderViewEditView = () => (
    <div className="student-questions-wrapper">

      {/* Back Button + Header */}
      <div className="sq-form-header">
        <button className="sq-back-btn" onClick={handleBack}>
          <i className="bi bi-arrow-left"></i> Back
        </button>
        <div>
          <h2 className="sq-form-title">
            {isEditing ? 'Edit Answer' : 'View Answer'}
          </h2>
          <p className="sq-form-subtitle">
            {isEditing ? 'Update your answer for the student' : 'Your answered question details'}
          </p>
        </div>
      </div>

      {/* Question Info Card */}
      <div className="sq-question-card">
        <div className="sq-question-card-header">
          <div className="sq-student-info">
            <img
              src={selectedQuestion?.student_avatar || `https://randomuser.me/api/portraits/men/${selectedQuestion?.id}.jpg`}
              alt={selectedQuestion?.student_name}
              className="sq-student-avatar"
            />
            <div>
              <span className="sq-student-name">{selectedQuestion?.student_name}</span>
              <span className="sq-subject-badge ms-2">{selectedQuestion?.subject}</span>
            </div>
          </div>
          <span className="sq-status-badge sq-status-answered">ANSWERED</span>
        </div>
        <div className="sq-question-display">
          <i className="bi bi-chat-left-quote me-2 text-muted"></i>
          {selectedQuestion?.question}
        </div>
      </div>

      {/* Answer Display or Edit Form */}
      <div className="sq-card">
        {errorMessage && (
          <div className="alert alert-danger py-2 mb-3">
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMessage}
          </div>
        )}
        {successMessage && (
          <div className="alert alert-success py-2 mb-3">
            <i className="bi bi-check-circle me-2"></i>
            {successMessage}
          </div>
        )}

        {!isEditing ? (
          /* READ — Answer Display */
          <div className="sq-answer-display-wrapper">
            <div className="sq-answer-display-header">
              <span>
                <i className="bi bi-check-circle-fill me-2 text-success"></i>
                <strong>Your Answer:</strong>
              </span>
              {/* Rating show karo agar hai */}
              {selectedQuestion?.rating && (
                <div className="sq-rating-display">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`bi ${i < selectedQuestion.rating ? 'bi-star-fill' : 'bi-star'}`}
                      style={{ color: i < selectedQuestion.rating ? '#fbbf24' : '#d1d5db' }}
                    ></i>
                  ))}
                </div>
              )}
            </div>
            <p className="sq-answer-text">{selectedQuestion?.answer}</p>

            <div className="sq-form-actions">
              <button
                type="button"
                className="sq-btn-cancel"
                onClick={handleBack}
              >
                Close
              </button>
              <button
                type="button"
                className="sq-btn-edit"
                onClick={() => {
                  setIsEditing(true);
                  setEditAnswerText(selectedQuestion?.answer || '');
                }}
              >
                <i className="bi bi-pencil-square me-2"></i>
                Edit Answer
              </button>
            </div>
          </div>
        ) : (
          /* UPDATE — Edit Form */
          <form onSubmit={handleAnswerUpdate} className="sq-answer-form-wrapper">
            <h5 className="sq-answer-form-heading">
              <i className="bi bi-pencil-square me-2"></i>
              Update your answer:
            </h5>

            <textarea
              className="sq-answer-textarea"
              rows="6"
              value={editAnswerText}
              onChange={(e) => setEditAnswerText(e.target.value)}
              required
            ></textarea>

            <div className="sq-form-actions">
              <button
                type="button"
                className="sq-btn-cancel"
                onClick={() => setIsEditing(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="sq-btn-submit"
                disabled={updateLoading}
              >
                {updateLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Updating...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle me-2"></i>
                    Update Answer
                  </>
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );

  return (
    <MyMasterLayout>
      {viewMode === 'list' && renderListView()}
      {viewMode === 'answer' && renderAnswerView()}
      {viewMode === 'view' && renderViewEditView()}
    </MyMasterLayout>
  );
};

export default StudentQuestions;